import { useBrand } from '@contexts/index'

import { CheckboxInput } from '../baseInputs'

const ShowroomTerms = ({ ...rest }) => {
  const brand = useBrand()

  const privacyLink =
    brand === 'lexus'
      ? 'https://www.lexus.co.uk/customer-data/privacy-policy'
      : 'https://www.toyota.co.uk/footer/privacy-policy'

  return (
    <div className="mt-8" data-gt-componentname="showroom-terms">
      <h5>
        CHECK: have you read/sent the data compliancy message to the customer?
      </h5>
      <p className="mb-8">
        To fulfil this request we need to send your information to your local
        retailer. Can you confirm you are happy for us to do this? If you would
        like to find out more about how we process your data please visit our
        <a
          className="underline"
          href={privacyLink}
          target={'_blank'}
          rel={'noopener noreferrer'}
          data-gt-name="ctaevent"
          data-gt-action="click-link"
          data-gt-label={privacyLink}
        >
          privacy notice
        </a>
        for details.
      </p>
      <CheckboxInput name="iscustomeraware" {...rest}>
        The customer is aware that their data is being transferred to the Centre
      </CheckboxInput>
    </div>
  )
}

export default ShowroomTerms
